<template>
    <div class="body">
        <div class="cardHead">
            <span class="cardA">
                <p class="cardP">
                    <span class="cardTitle">
                        <img class="cardImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/cardAdd.png"/>
                    </span>
                    <span class="cardContentA">录入产品</span>
                </p>
                <p class="cardP">
                    <span class="cardTitle">名称:</span>
                    <span class="cardContent"><el-input class="cardInput"  v-model="cardAdd.name" placeholder="起始编号"></el-input></span>
                    <span class="cardTitle">数量:</span>
                    <span class="cardContent"><el-input class="cardInput" v-model="cardAdd.inventory"  placeholder="结束编号"></el-input></span>
                    <span class="cardTitleA"></span>
                </p>
                 <p class="cardP">
                    <span class="cardTitle">简介</span>
                    <span class="cardContentB">
                        <el-input placeholder="请输入介绍" v-model="cardAdd.remark"  maxlength="200" show-word-limit ></el-input>
                    </span>
                </p>

                <el-button class="cardButton" size="small" type="primary" @click="sendAdd">确定录入</el-button>
            </span>
        </div>
        <div class="table">
                <div class="title">
                    <span class="search">
                        <el-input class="searchInput" v-model="page.condition.name"  @change="search" placeholder="姓名/手机号"></el-input>
                    </span>
                    <!-- <span class="sortA">
                        <el-date-picker  v-model="time" value-format="yyyy-MM-dd" type="daterange" range-separator="-"  start-placeholder="开始日期" end-placeholder="结束日期" @change="timeSection"></el-date-picker>
                    </span> -->
                    <!-- <span class="sortB">
                       <el-select v-model="page.condition.type" placeholder="请选择">
                            <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </span> -->
                    <!-- <span class="sortC">
                        <el-button type="primary" @click="search">查询</el-button>
                        <el-button plain @click="reset">重置</el-button>
                    </span> -->
                </div>
                <!-- <p class="tableFiltrate">
                    
                </p> -->
                <div class="tableList">
                     <el-table  :data="list" :header-cell-style="tableHeaderColor" v-loading="loading"  style="width: 100%">
                        <el-table-column prop="name"  label="名称"  width="180"></el-table-column>
                        <el-table-column  prop="inventory" label="数量" width="180"></el-table-column>
                        <el-table-column prop="remark" label="介绍"></el-table-column>
                        <el-table-column prop="entryName" label="添加人"></el-table-column>
                        <el-table-column prop="entryDt" label="添加时间"></el-table-column>
                        <el-table-column  prop="datumStatus" label="操作">
                            <template slot-scope="scope">
                                <img class="imgOpera" @click="redactGitf(scope.row)" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/xiugai.png">
                                <img class="imgOpera" @click="deleteGitf(scope.row)" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/shanchu.png">
                            </template>
                        </el-table-column>
                    </el-table>
                    <p class="customPage"><span ><el-pagination  background layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size"  :total="total"></el-pagination></span></p>
                </div>



                <el-dialog title="礼品编辑" :visible.sync="dialogFormVisible">
                    <el-form :model="form">
                        <el-form-item label="名称" :label-width="formLabelWidth">
                        <el-input v-model="form.name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="数量" :label-width="formLabelWidth">
                        <el-input v-model="form.inventory" placeholder="请输入增减数量" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="简介" :label-width="formLabelWidth">
                            <el-input type="textarea"  :rows="2" placeholder="请输入内容" v-model="form.remark"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="sendRedact">确 定</el-button>
                    </div>
                </el-dialog>
               
                
        </div>
        <!-- 会员卡 -->
    </div>
</template>

<script>
    export default {
      data() {
        return {    
          page:{
                condition:{
                    name:null,
                    key:null,
                    type:null,

                    datumStatus:null,
                    source:null,
                    startDt:null,
                    endDt:null,
                    departmentKey:null,
                },
                current:1,
                size:8,
                sorts:[
                    {
                        sortColumn:'id',
                        sortType:'DESC',
                    }
                ]
            },
            list:[],
            total:null,
            time: '',
            loading:true,
            options: [
                {value: '1',label: '录入会员卡'},
                {value: '2',label: '发放会员卡'}, 
                {value: '3',label: '回收会员卡'}, 
                {value: '4',label: '删除会员卡'}
            ],
            vipList:[],
            cardAdd:{
                name:null,
                inventory:null,
                remark:null,
            },
            dialogFormVisible: false,
            form: {
                id: null,
                name: null,
                inventory: null,
                remark: null,
            },
            formLabelWidth: '120px'
        
        }
      },
      mounted(){
          this.cardList()
          this.getVipType()
      },
      methods:{

            //确认修改产品
            sendRedact(){
                console.log(this.form)
                this.dialogFormVisible = false
                this.joker.grant.giftUpdate(this.form).then(res=>{
                    console.log(res)
                    this.cardList()
                })
            },
            //修改礼品
            redactGitf(row){
                console.log(row)
                this.dialogFormVisible = true
                this.form = row
                this.form.inventory = 0
            },
            //删除礼品
            deleteGitf(row){
                this.joker.grant.giftDelete(row.id).then(res=>{
                    console.log(res)
                    this.cardList()
                })
            },

            //会员卡列表
            getVipType(){
                this.joker.grant.getVipType().then(res=>{
                    console.log(res)
                    this.vipList = res.content
                })
            },

            //录入会员卡
            sendAdd(){
                if(this.cardAdd.name!=null && this.cardAdd.inventory!=null && this.cardAdd.remark!=null){
                    this.joker.grant.addProduct(this.cardAdd).then(res=>{
                        console.log(res)
                        alert('添加成功')
                        this.cardList()
                    })
                }else{
                    alert("填写异常")
                }
            },


            //分页
            cardList(){
                this.loading = true
                this.joker.grant.productList(this.page).then(res=>{
                    console.log(res)
                    this.list = res.content.records
                    this.total = res.content.total
                    this.loading = false
                })
            },
           //下一页
            handleCurrentChange(val) {
                console.log(val)
                this.page.current = val
                this.cardList();
            },
             //搜索
            search(){
                this.page.current = 1
                this.cardList();
            },
            //时间范围
            timeSection(e){
                console.log(this.time[0])
                this.page.condition.startDt = this.time[0]+' 00:00:00'
                this.page.condition.endDt = this.time[1]+' 23:59:59'
                console.log(this.page)
            },
            //重置
            reset(){
                this.page.condition.key = null
                this.page.condition.type = null
                this.page.condition.startDt = null
                this.page.condition.endDt = null
                this.page.current = 1
                this.cardList();
            },
            // 修改table header的背景色
            tableHeaderColor({ row, column, rowIndex, columnIndex }){
                if (rowIndex === 0) {
                    return 'background-color: #ECEEF0;color: #606266'
                }
            },
      }
    }
  </script>

<style scoped>
    .cardHead{
        margin-top: 1%;
    }
    .cardA{
        display: inline-block;
        background-color:#FFFFFF;
        width:92%;
        border-radius: 10px;
        /* margin-left: 2%; */
    }
    .card{
        display: inline-block;
        background-color:#FFFFFF;
        width: 20%;
        border-radius: 10px;
        margin-left: 4%;
    }
    
    .cardTitle{
        display: inline-block;
        width: 5%;
        /* background-color: aqua; */
    }
    .cardTitleA{
        display: inline-block;
        width: 44%;
        /* background-color: aqua; */
        /* background-color: aquamarine; */
    }
    .cardContentB{
        display: inline-block;
        width: 90%;
        line-height: 30px;
        /* background-color: blue; */
        vertical-align: middle;
        font-weight: 600;
        text-align: left;
        font-size: 18px;
    }
    .cardContentA{
        display: inline-block;
        width: 90%;
        line-height: 30px;
        /* background-color: blue; */
        vertical-align: middle;
        font-weight: 600;
        text-align: left;
        font-size: 18px;
    }
    .cardContent{
        display: inline-block;
        width: 20%;
        line-height: 30px;
        /* background-color: blue; */
        vertical-align: middle;
        font-weight: 600;
        text-align: left;
        font-size: 18px;
    }
    .cardImg{
        vertical-align: middle;
        width: 30px;
        height: 30px;
    }
    .cardInput{
        /* width: 50%; */
    }
    .cardP{
        margin-top: 1%;
        /* line-height: 45px; */
        /* background-color: aqua; */
        
    }
    .cardButton{
        margin-top: 0.5%;
        margin-bottom: 0.5%;
    }
    .table{
        margin-top: 1%;
        /* height: 75%; */
        width: 92%;
        margin-left: 4%;
        border-radius: 10px;
        background-color: #FFFFFF;
    }
    .tableList{
        width: 96%;
        margin-left: 2%;
    }
    .search{
        display: inline-block;
        width: 50%;
        /* background-color: #5790DF; */
    }

    .tableFiltrate{
        background-color: #FFFFFF;
        padding-top: 1%;
        padding-bottom: 1%;
        border-radius: 10px;
    }
    .customPage{
        margin-top: 1%;
        padding-bottom: 1%;
    }
    .searchInput{
        width: 35%;
        margin-left: 1%
    }
    .title{
        background-color: #FFFF;
        width: 96%;
        line-height: 60px;
        margin-bottom: 0.5%;
        border-radius: 10px;
    }
    .cardSelect{
        width: 98%;
    }

    


</style>


// WEBPACK FOOTER //
// src/components/Grant/GrantProduct/grantProduct.vue